// Bundle.js - Snap Recommendations Setup

// Global Configuration for Snap Recommendations
const RecommendationInstantiator = (function () {
    const recommendations = {
        init: function () {
            // Ensure all recommendation script blocks are processed
            const scripts = document.querySelectorAll('script[type="searchspring/recommendations"]');
            scripts.forEach(script => {
                try {
                    const data = eval(`(${script.textContent})`);
                    recommendations.processScript(data, script);
                } catch (e) {
                    //console.error("Error processing recommendations script: ", e);
                }
            });
        },
        processScript: function (data, script) {
            if (data.profiles && data.profiles.length > 0) {
                data.profiles.forEach(profile => {
                    const target = document.querySelector(profile.selector);
                    if (target) {
                        recommendations.fetchData(profile, target);
                    }
                });
            }
        },
        fetchData: function (profile, target) {
            const apiUrl = `https://api.searchspring.net/recommendations?tag=${profile.tag}&limit=${profile.options?.limit || 20}`;
            fetch(apiUrl)
                .then(response => response.json())
                .then(data => {
                    recommendations.render(target, data);
                })
                .catch(error => console.error("Error fetching recommendations: ", error));
        },
        render: function (target, data) {
            if (data && data.results) {
                const html = data.results.map(product => `
                    <div class="recommendation-item">
                        <img src="${product.image}" alt="${product.title}" />
                        <a href="${product.url}">${product.title}</a>
                        <span>${product.price}</span>
                    </div>
                `).join('');
                target.innerHTML = html;
            } else {
                target.innerHTML = `<p>No recommendations available.</p>`;
            }
        }
    };
    return recommendations;
})();

// Initialize recommendations on page load
document.addEventListener('DOMContentLoaded', function () {
    RecommendationInstantiator.init();
});
